import axios from '@/utils/request';
const v1 = 'v1/admin';

export const getPayments = () => axios.get(`${v1}/payments/index`);
